import {jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class Tag {
    @jsonMember
    id: number;
    @jsonMember
    name: string;
}
